import { ErrorPayload } from '@redux/common/types';
import { ThunkParams } from '@redux/types';
import { getSystemPromptCategoriesAction } from './caregiverAssistantActions';
import { SystemPromptCategory } from './caregiverAssistantTypes';

function processGetSystemPromptCategoriesSuccess(payload: SystemPromptCategory[]) {
  return function (dispatch: Function, getState: Function, { apiClient }: ThunkParams) {
    dispatch(getSystemPromptCategoriesAction.success(payload));
  };
}

function processGetSystemPromptCategoriesFail(error: ErrorPayload) {
  return function (dispatch: Function, getState: Function, { apiClient }: ThunkParams) {
    dispatch(getSystemPromptCategoriesAction.fail(error));
  };
}

export function getSystemPromptCategoriesThunk(activeOnly: boolean = true) {
  return async function (dispatch: Function, getState: Function, { apiClient }: ThunkParams) {
    dispatch(getSystemPromptCategoriesAction.start());
    return apiClient.get(`/v1/engagementPlan/systemPromptCategories?activeOnly=${activeOnly}`, {
      auth: true,
      successAction: processGetSystemPromptCategoriesSuccess,
      failAction: processGetSystemPromptCategoriesFail
    });
  };
}
